module.exports = __webpack_public_path__ + "public/img/finishTask.3b000e50.png";